import moment from 'moment'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {

    name: 'InputDatePicker',

    components: {
        DatePicker
    },

    props: {
        label: String,
        required: Boolean,
        value: Date,
        disabled: Boolean,
        type: {
            default: "date", // or dateTime
            type: String
        }
    },
    //On update, update date and emit event
    watch:{date:function (val){
            this.date=val
            this.$emit("updated",this.date)
          }
        },


        data() {
        return {
            date: this.value || new Date()
        }
    },

    methods: {
        previous() {
            if (!this.disabled) {
                const date = new Date(this.date)
                date.setDate(this.date.getDate() - 1)
                this.date = date
            }
        },

        next() {
            if (!this.disabled) {
                const date = new Date(this.date)
                date.setDate(this.date.getDate() + 1)
                this.date = date
            }
        },

        checkForError() {
            this.error = this.value || !this.required ? '' : 'input-date-error'
            return this.error
        }
    }
}